import { styled, Typography } from 'opensolar-ui'
import React from 'react'

type PropTypes = {
  integration: string
}

const Wrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  margin: '32px 0px',
})

const CreditApplicationIntro: React.FC<PropTypes> = (props) => {
  if (props.integration !== 'propensio') return null
  return (
    <Wrapper>
      <Typography textVariant="h5">Loan Application Form</Typography>
      <Typography textVariant="body1">
        By submitting this application, you acknowledge that Propensio Finance Limited will process your personal data
        to assess your application and, if approved, manage any resulting agreement. This processing is necessary to
        fulfil our contractual obligations, meet legal requirements, and to pursue our legitimate interests, as outlined
        in our{' '}
        <a href="https://www.propensio.co.uk/legals/privacy/" target="_blank" rel="noopener noreferrer">
          privacy policy
        </a>
      </Typography>
    </Wrapper>
  )
}

export default CreditApplicationIntro
